import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-brand-gray px-4 py-4 sm:px-6 sm:py-5" aria-labelledby="faq-heading" data-id="element-35" data-mp="1hcrxiameb0tt">
      <h2 id="faq-heading" className="mb-2.5 text-center text-[19px] font-extrabold uppercase leading-tight text-brand-navy sm:text-3xl" data-id="element-36" data-mp="1cf9ka81chzg0">
        Domande Frequenti
      </h2>
      <div className="mx-auto max-w-xl space-y-1.5" data-id="element-37" data-mp="252vzkdjxqsip">
        {faqs.map((faq, index) => <article key={faq.question} className="overflow-hidden rounded-lg bg-white shadow-sm" data-id="element-38" data-mp="203jcpst2dlg4" data-mpi={index}>
            <button type="button" aria-expanded={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between gap-2 px-3 py-2 text-left hover:bg-brand-green/10 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-brand-green" data-id="element-39" data-mp="1v5hicbq6tzpc">
              <span className="text-[11.5px] font-extrabold leading-snug text-brand-navy sm:text-xs" data-id="element-40" data-mp="1pmtbo43obxu1">
                {faq.question}
              </span>
              <ChevronDownIcon className={`h-4 w-4 shrink-0 text-brand-green transition-transform ${openIndex === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-41" data-mp="1aorag0k47ofy" />
            </button>
            {openIndex === index && <p className="px-3 pb-2 text-[11.5px] font-medium leading-snug text-brand-ink/80 sm:text-xs" data-id="element-42" data-mp="16o7bcrfzear6">
                {faq.answer}
              </p>}
          </article>)}
      </div>
    </section>;
}